import { render, staticRenderFns } from "./redActManagement.vue?vue&type=template&id=146704f2&scoped=true&"
import script from "./redActManagement.vue?vue&type=script&lang=js&"
export * from "./redActManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146704f2",
  null
  
)

component.options.__file = "redActManagement.vue"
export default component.exports